module.exports = __webpack_public_path__ + "img/gb-eng.eabfeadc.svg";